import type { ApiUser, UserType } from './auth';

// Re-export types
export * from './auth';
export * from './contractor';
export * from './lender';
export * from './listing';

// Admin User (derived from ApiUser for store usage)
export interface User {
  id: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  type: UserType;
}

// Helper to convert API user to store user
export function mapApiUserToUser(apiUser: ApiUser): User {
  return {
    id: apiUser._id,
    email: apiUser.email,
    name: `${apiUser.firstName} ${apiUser.lastName}`.trim(),
    firstName: apiUser.firstName,
    lastName: apiUser.lastName,
    type: apiUser.type,
  };
}

export interface Property {
  id: string;
  address: string;
  price: number;
  status: 'active' | 'pending' | 'sold';
}

export interface DashboardStats {
  totalUsers: number;
  activeProperties: number;
  pendingRequests: number;
}
